export const defaultFont = Object.freeze({
    light: 300,
    regular: 400,
    medium: 500, 
});